import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessagesSquare, Plus } from 'lucide-react';
import Button from '../Button';
import { ResearchProjectStyle } from './ResearchProject.style';
import ThreadCard from '../ThreadCard';
import OverlayModal from '../ui/OverlayModal';
import AddChatModal from '../AddChatModal';
import projectService from '../../services/projectService';
import { useParams } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Loaders from '../Loaders';
import { BackLink } from '../ui/ui.styles';

const ResearchProjectBlock = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [addChatOpen, setAddChatOpen] = useState(false);
  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  const { _data, _loading } = projectService.GetProjectSessions(id, fetch);

  return (
    <ResearchProjectStyle>
      {addChatOpen && (
        <OverlayModal
          title="Add Chats"
          onClose={() => setAddChatOpen(false)}
          width={640}
          placement="center">
          <AddChatModal onClose={() => setAddChatOpen(false)} refetch={refetch} />
        </OverlayModal>
      )}

      <BackLink type="button" onClick={() => navigate('/projects')}>
        <ArrowLeft size={16} /> Back to Projects
      </BackLink>

      <div className="project-header">
        {_loading ? null : (
          <>
            <strong className="heading">{_data?.project_name}</strong>
            <p>{_data?.description}</p>
          </>
        )}
      </div>

      <div className="threads-head">
        <strong className="title">Chat Threads</strong>
        <Button width="150px" onClick={() => setAddChatOpen(true)}>
          <Plus size={16} /> Add Chat
        </Button>
      </div>

      <div className="scroll-area">
        {_loading ? (
          <div className="section-loader">
            <Loaders viewLoader />
          </div>
        ) : !_data?.sessions?.length ? (
          <div className="no-threads">
            <MessagesSquare size={40} className="empty-icon" />
            <p>
              Start chatting to add threads to this project,
              <br /> or use Add Chat to link existing chats.
            </p>
          </div>
        ) : (
          <div className="threads-list">
            <ThreadCard threadCardsData={_data?.sessions} refetch={refetch} />
          </div>
        )}
      </div>
    </ResearchProjectStyle>
  );
};

export default ResearchProjectBlock;
